import { Flag, Shirt, ToolCase } from 'lucide-react';
import { Journal, Run } from '@nike/nike-design-system-icons';
export const menuMain = [
    { label: 'Projects', id: 'Projects', url: '/projects/view', icon: Journal },
    {
        label: 'Expressions',
        id: 'Expressions',
        url: '/expressions/view',
        icon: Run
    },
    { label: 'Products', id: 'Products', url: '/product-matrix', icon: Shirt },
    {
        label: 'Admin Tools',
        id: 'Admin Tools',
        url: '#',
        icon: ToolCase,
        sub: [
            {
                label: 'Feature Flags',
                id: 'Feature Flags',
                url: '/admin-tools/features',
                icon: Flag
            }
        ]
    }
];
export const menuAvatar = [
    {
        label: 'My Account',
        id: 'My Account',
        group: [
            {
                label: 'Profile',
                id: 'Profile',
                url: '#'
            },
            { label: 'Saved Views', id: 'Saved Views', url: '/manage-saved-views' }
        ]
    }
];
